import { render, staticRenderFns } from "./UserGuideCollections.vue?vue&type=template&id=17b82828&"
import script from "./UserGuideCollections.vue?vue&type=script&lang=ts&"
export * from "./UserGuideCollections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports